import { useNavigate } from 'react-router-dom'
import styles from './ChamadoTable.module.css'
import { __PRIORIDADES } from '../../config'
import AccessButton from '../layout/AccessButton'
import PrioridadeCard from '../project/PrioridadeCard'
import SituacaoBadge from '../project/SituacaoBadge'

function ChamadoTable({chamados, titleText, nowTick}) {

    let primeiraData = '';
    const parseDateTime = (value) => {
        if (!value || typeof value !== 'string') return null
        if (value.includes('/')) {
            const [datePart, timePart] = value.split(' ')
            const [day, month, year] = datePart.split('/').map(Number)
            const [hour = 0, minute = 0, second = 0] = (timePart || '').split(':').map(Number)
            const parsed = new Date(year, (month || 1) - 1, day || 1, hour || 0, minute || 0, second || 0)
            return Number.isNaN(parsed.getTime()) ? null : parsed
        }
        const normalized = value.includes('T') ? value : value.replace(' ', 'T')
        const parsed = new Date(normalized)
        return Number.isNaN(parsed.getTime()) ? null : parsed
    }
    const isSameDay = (a, b) => (
        a.getFullYear() === b.getFullYear()
        && a.getMonth() === b.getMonth()
        && a.getDate() === b.getDate()
    )
    const navigate = useNavigate();

    return (
            <div className={styles.tableWrapper}>
            <table className={styles.chamadosTable}>
                <thead>
                {titleText !== undefined && (<tr><th colSpan="10">{titleText}</th></tr>)}
                <tr>
                    <th></th>
                    <th>Nº</th>
                    <th>Prioridade</th>
                    <th>Situação</th>
                    <th>Empresa</th>
                    <th>Autor</th>
                    <th>Última Atividade</th>
                    <th>Fechamento</th>
                    <th>Responsável</th>
                    <th>TAGs</th>
                </tr>
                </thead>
                <tbody>
                {chamados.map((chamado) => {
                    let prioridadeTexto = chamado.PRIORIDADE_INTERNA ? (__PRIORIDADES.filter((p) => { return p.value === parseInt(chamado.PRIORIDADE_INTERNA) })).shift().label.toUpperCase(): 'SEM PRIORIDADE';
                    let responsaveis = (chamado.USUARIOS.filter((usr) => { return parseInt(usr.ATRIBUICAO) === 3 }));
                    let quebraLinha = false;
                    let prioridadeClass = chamado.PRIORIDADE_INTERNA === null ? 'noprior' : `prior-${chamado.PRIORIDADE_INTERNA}`;

                    // let pos = 0;
                    if ( chamado.DT_ABERTURA.split(" ")[0] !== primeiraData ) {
                        quebraLinha = true;
                        primeiraData = chamado.DT_ABERTURA.split(" ")[0]; 
                        // pos = chamadosSemResp.push(primeiraData);
                    }

                    // if (responsaveis.length == 0)

                    let labelResponsavel = responsaveis.length > 0 ? (`${responsaveis[0].CD_USUARIO}` + (responsaveis.length > 1 ? ` (${responsaveis.length})` : '' ) ) : 'SEM RESPONSÁVEL'
                    let responsaveisLabel = responsaveis.length > 0
                        ? responsaveis.map((usr) => { return usr.CD_USUARIO; }).join(', ')
                        : 'SEM RESPONSÁVEL'
                    let responsaveisNomes = responsaveis.map((usr) => { return usr.CD_USUARIO; })
                    let tagsNomes = chamado.MOTIVOS.map((motivo) => { return motivo.TX_MOTIVO; })
                    let tagPrimeira = tagsNomes[0] || 'SEM TAGS'
                    let tagsOcultas = tagsNomes.slice(1)
                    let tagsLabel = tagsOcultas.length > 0 ? `${tagPrimeira} (${tagsOcultas.length})` : tagPrimeira
                    let chamadoLink = `/chamado/${chamado.ID}`
                    let openedAt = parseDateTime(chamado.DT_ABERTURA)
                    let now = nowTick || Date.now()
                    let isNew = openedAt ? isSameDay(openedAt, new Date(now)) : false

                    return (<>
                            {quebraLinha &&
                            (
                            <tr className={styles.quebraLinha}>
                                <td colSpan="10">Data de Abertura: {primeiraData}</td>
                            </tr>)}
                        <tr
                            className={styles.rowLink}
                            role="link"
                            tabIndex={0}
                            onClick={() => navigate(chamadoLink)}
                            onKeyDown={(event) => {
                                if (event.key === 'Enter' || event.key === ' ') {
                                    event.preventDefault()
                                    navigate(chamadoLink)
                                }
                            }}
                        >
                            <td className={styles.chamadoHeadAcoes}>
                                <AccessButton to={chamadoLink}/>
                            </td>
                            <td>
                                <span className={styles.idBadge}>#{chamado.ID}</span>
                                {isNew && <span className={styles.badgeNew}>NOVO</span>}
                            </td>
                            <td className={styles.chamadoHeadPrioridade}>
                                <span className={`${styles.prioridadeBadge} ${styles[prioridadeClass]}`}>{prioridadeTexto}</span>
                                {chamado.SLA_INTERNA_STATUS && <span className={styles.slaText}>{chamado.SLA_INTERNA_STATUS}</span>}
                            </td>
                            <td className={styles.chamadoHeadSituacao}>
                                <SituacaoBadge situacao={chamado.TP_SITUACAO} />
                            </td>
                            <td className={styles.chamadoHeadEmpresas}>{chamado.EMPRESA_SIGLA || chamado.EMPRESA_REQUISITANTE}</td>
                            <td className={styles.chamadoHeadUsrAutor}>{chamado.CD_USUARIO_AUTOR} <br></br> <PrioridadeCard prioridade={chamado.PRIORIDADE_EXTERNA} SLA={chamado.SLA_EXTERNA_STATUS} /></td>
                            <td className={styles.chamadoHeadDtAtv}> {chamado.CD_USUARIO_ULTIMA_ATV}<br></br>{chamado.DT_ULTIMA_ATIVIDADE}</td>
                            <td className={styles.chamadoHeadDtFchm}>{chamado.DT_FINALIZACAO ? chamado.DT_FINALIZACAO.substr(0, 10) : ''}</td>
                            <td className={styles.chamadoHeadResponsaveis}>
                                <span className={styles.responsaveisHover}>
                                    {labelResponsavel}
                                    <span className={styles.responsaveisPopover}>
                                        {responsaveisNomes.length > 0 ? (
                                            <span className={styles.responsaveisGrid}>
                                                {responsaveisNomes.map((nome, index) => (
                                                    <span key={`resp-${chamado.ID}-${index}`} className={styles.responsaveisItem}>{nome}</span>
                                                ))}
                                            </span>
                                        ) : 'SEM RESPONSÁVEL'}
                                    </span>
                                </span>
                            </td>
                            <td className={styles.chamadoHeadTags}>
                                <span className={styles.tagsHover}>
                                    {tagsLabel}
                                    {tagsOcultas.length > 0 && (
                                        <span className={styles.tagsPopover}>
                                            {tagsOcultas.map((tag, index) => (
                                                <span key={`tag-${chamado.ID}-${index}`} className={styles.tagsItem}>{tag}</span>
                                            ))}
                                        </span>
                                    )}
                                </span>
                            </td>
                        </tr>
                    </>)
                })}
                </tbody>

        </table>
            </div>
        )
}

export default ChamadoTable


///     
